import React from 'react';
import { displayClientName } from '../clientNameUtils';

export const TYPE_LABEL = {
  intake: 'Intake / Welcome',
  card_update: 'Card-Update',
  roi: 'Release of Information',
};
export const PAY_METHOD_LABEL = { card: 'Card', cash_check: 'Cash / Check', already_provided: 'Already on file' };
const STATUS_STYLE = {
  completed: { color: 'var(--success-color)' },
  pending: { color: 'var(--accent-color)' },
  expired: { color: 'var(--text-muted)' },
};

export const fmtName = displayClientName;
export function fmtDate(d) {
  if (!d) return '';
  const dt = new Date(d);
  return isNaN(dt) ? '' : dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

const th = { textAlign: 'left', borderBottom: '1px solid var(--border-color)', padding: '8px', fontSize: 13 };
const td = { borderBottom: '1px solid var(--surface-muted)', padding: '8px', fontSize: 14 };

// Renders a list of payment/intake/ROI link rows as a desktop table and, on
// narrow screens, stacked cards (same pattern as the Log Sessions page).
export default function LinkStatusList({ rows, showSentTo = false }) {
  const statusCell = (l) => ({ fontWeight: 600, textTransform: 'capitalize', ...STATUS_STYLE[l.status] });

  return (
    <>
      <style>{`
        .lsl-card { background:#fff; border:1px solid var(--border-color); border-radius:8px; padding:1rem; margin-bottom:1rem; }
        .lsl-card .row { display:flex; justify-content:space-between; gap:12px; margin:2px 0; font-size:14px; }
        .lsl-card .lbl { color: var(--text-muted); }
        @media (max-width:750px){ .lsl-desktop{ display:none; } }
        @media (min-width:751px){ .lsl-mobile{ display:none; } }
      `}</style>

      <div className="lsl-desktop" style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={th}>Client</th>
              <th style={th}>Link Type</th>
              <th style={th}>Payment Method</th>
              <th style={th}>Sent</th>
              <th style={th}>Status</th>
              <th style={th}>Completed</th>
              {showSentTo && <th style={th}>Sent To</th>}
            </tr>
          </thead>
          <tbody>
            {rows.map((l, i) => (
              <tr key={`${l.linkType}-${l.id}`} style={{ background: i % 2 === 0 ? 'var(--white)' : 'var(--surface-muted)' }}>
                <td style={td}>{fmtName(l.clientName)}</td>
                <td style={td}>{TYPE_LABEL[l.linkType] || l.linkType}</td>
                <td style={td}>{PAY_METHOD_LABEL[l.paymentMethod] || ''}</td>
                <td style={td}>{fmtDate(l.sentAt)}</td>
                <td style={{ ...td, ...statusCell(l) }}>{l.status}</td>
                <td style={td}>{fmtDate(l.completedAt)}</td>
                {showSentTo && <td style={td}>{l.sentToEmail || ''}</td>}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="lsl-mobile">
        {rows.map((l) => (
          <div key={`${l.linkType}-${l.id}`} className="lsl-card">
            <div className="row">
              <strong>{fmtName(l.clientName)}</strong>
              <span style={statusCell(l)}>{l.status}</span>
            </div>
            <div className="row"><span className="lbl">Type</span><span>{TYPE_LABEL[l.linkType] || l.linkType}</span></div>
            {PAY_METHOD_LABEL[l.paymentMethod] && (
              <div className="row"><span className="lbl">Payment</span><span>{PAY_METHOD_LABEL[l.paymentMethod]}</span></div>
            )}
            <div className="row"><span className="lbl">Sent</span><span>{fmtDate(l.sentAt) || '—'}</span></div>
            <div className="row"><span className="lbl">Completed</span><span>{fmtDate(l.completedAt) || '—'}</span></div>
            {showSentTo && l.sentToEmail && (
              <div className="row"><span className="lbl">Sent to</span><span>{l.sentToEmail}</span></div>
            )}
          </div>
        ))}
      </div>
    </>
  );
}
